export default {
    state: {
    },
    mutations: {
    },
    actions: {
        async getZonesDataTableInfo({dispatch}, obj) {
            return await dispatch('apiQuery', {method:`/reports/zones?date_begin=${obj.date_begin}&date_end=${obj.date_end}`})
        }
    },
    getters: {
    }
}